// Payment declined / timed out. Retry (when allowed) restarts the order;
// Cancel returns to idle.

import { Banner } from "../components/Banner";
import { Button } from "../components/Button";
import { BangMark } from "../components/Illustrations";
import { KioskShell } from "../components/KioskShell";
import { useLang } from "../i18n/LangContext";
import type { KioskState } from "../state/types";
import type { Dispatch } from "./shared";

type PaymentFailed = Extract<KioskState, { phase: "payment-failed" }>;

export function PaymentFailedScreen({
  state,
  dispatch,
}: {
  state: PaymentFailed;
  dispatch: Dispatch;
}) {
  const { t } = useLang();
  return (
    <KioskShell step={3}>
      <div className="screen screen--center">
        <div className="status-badge status-badge--error badge-pop">
          <BangMark />
        </div>
        <h1 className="screen__title">{t("payFailedTitle")}</h1>
        <Banner variant="error">
          {state.reason === "confirmFailedReason"
            ? t("confirmFailedReason")
            : state.reason}
        </Banner>
        {state.hint ? <p className="screen__note">{t(state.hint)}</p> : null}
        {state.showOrderId && state.orderId !== null ? (
          <p className="screen__note">
            {t("orderNumberLabel", { orderId: String(state.orderId) })}
          </p>
        ) : null}
        {/* The card may already be charged: never suggest another card. */}
        {state.hint !== "hintVerifyCharge" ? (
          <p className="screen__note">{t("payFailedHint")}</p>
        ) : null}
        <div className="screen__actions">
          {state.allowRetry ? (
            <Button onClick={() => dispatch({ type: "start" })} size="lg">
              {t("tryAgain")}
            </Button>
          ) : null}
          <Button
            onClick={() => dispatch({ type: "cancel" })}
            variant="secondary"
          >
            {t("cancel")}
          </Button>
        </div>
      </div>
    </KioskShell>
  );
}
